import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken } from '../../GlobalStateContainer/actions'
import $ from 'jquery'

const EMULATION_MODE_HOLIDAYS = false


/*
 * Holiday Actions
 * 
 */

export function fetchHolidaysList(dispatch) {
    let cmd = 'FETCH_HOLIDAYS_LIST'

    execWithApiToken(dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        var url = buildRequestUrl('Holidays');
        axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd + '_FULFILLED',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })
    })
}

export function fetchHolidayTypes() {
    let cmd = 'RETRIEVE_HOLIDAY_TYPES'

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {

        axios.get(buildRequestUrl('Holidays/HolidayTypes'), { headers: { 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: cmd,
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })

    })
}

export function fetchHoliday(id, viewMode) {
    let cmd = 'FETCH_HOLIDAY'

    execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
        dispatch(
            {
                type: cmd
            }
        )

        axios.get(buildRequestUrl('Holidays/HolidayTypes'), { headers: { 'Authorization': 'Bearer ' + token } })
            .then((resp) => {
                dispatch(
                    {
                        type: 'RETRIEVE_HOLIDAY_TYPES',
                        payload: resp
                    }
                )
            })
            .catch((err) => {
                dispatch(
                    {
                        type: cmd + '_REJECTED',
                        payload: err
                    }
                )
            })

        if (viewMode === false) {
            var url = buildRequestUrl('Holidays/') + id;
            axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        }


    })
}

export function createHoliday(holiday) {
    let cmd = 'CREATE_HOLIDAY'

    if (EMULATION_ALL || EMULATION_MODE_HOLIDAYS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: holiday
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('Holidays'), JSON.stringify(holiday), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateHoliday(id, holiday) {
    let cmd = 'UPDATE_HOLIDAY'

    if (EMULATION_ALL || EMULATION_MODE_HOLIDAYS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: holiday
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('Holidays/') + id, JSON.stringify(holiday), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorHoliday(dispatch) {

    dispatch(
        {
            type: 'HOLIDAY_ERROR'
        }
    )
}

export function fetchHolidayError(dispatch) {

    dispatch(
        {
            type: 'FETCH_HOLIDAYS_ERROR'
        }
    )
}